import React, { useState } from 'react';
import { useIntl } from 'react-intl';

import { Button } from '@/components/buttons/Button';
import { isBiometricLoginAvailable } from '@/hooks/useBiometricLogin';
import { getBiometricChoice, setBiometricChoice } from '@/utils/biometric-storage';

const BiometricSettings = () => {
  const intl = useIntl();
  const [choice] = useState(getBiometricChoice);
  const [confirmed, setConfirmed] = useState(false);

  if (!isBiometricLoginAvailable() || choice !== 'declined') {
    return null;
  }

  const handleEnable = () => {
    setBiometricChoice(null);
    setConfirmed(true);
  };

  return (
    <section
      className="mx-auto mb-4 max-w-[720px] flex flex-wrap justify-between py-8 px-4 bg-white rounded-md
      sm:p-8 sm:pb-8"
    >
      <div className="flex items-center gap-3 w-full mb-4">
        <svg
          width="28"
          height="28"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
          className="text-blue-light flex-shrink-0"
        >
          <path d="M2 12C2 6.5 6.5 2 12 2a10 10 0 0 1 8 4" />
          <path d="M5 19.5C5.5 18 6 15 6 12c0-3.5 2.5-6 6-6 2 0 3.5 1 4.5 2.5" />
          <path d="M12 10c-1.1 0-2 .9-2 2 0 3-1 5.5-2.5 7.5" />
          <path d="M12 10c1.1 0 2 .9 2 2 0 2-.5 4-1.5 5.5" />
          <path d="M8.5 16.5c-.5 1.5-1 3-2 4.5" />
          <path d="M20 2v4h-4" />
        </svg>
        <h2 className="mt-0 text-[22px]">
          {intl.formatMessage({ id: 'biometric.settings.title' })}
        </h2>
      </div>
      {confirmed ? (
        <p className="text-green-600 w-full">
          {intl.formatMessage({ id: 'biometric.settings.confirmation' })}
        </p>
      ) : (
        <>
          <p className="text-gray-600 mb-6 w-full">
            {intl.formatMessage({ id: 'biometric.settings.description' })}
          </p>
          <Button
            btnType="primary"
            text={intl.formatMessage({ id: 'biometric.settings.enable' })}
            onClickHandler={handleEnable}
          />
        </>
      )}
    </section>
  );
};

export default BiometricSettings;
